const GCLID_STORAGE_KEY = 'gclid'

export function getStoredGclid(): string | null {
  try {
    return window.sessionStorage.getItem(GCLID_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

export function storeGclid(gclid: string): void {
  try {
    window.sessionStorage.setItem(GCLID_STORAGE_KEY, gclid)
  } catch (error) {}
}
